"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCustomError = void 0;
const isCustomError = function (ex) {
    return (typeof ex === 'object' &&
        ex !== null &&
        'message' in ex && typeof ex.message === 'string' &&
        'name' in ex && typeof ex.name === 'string' &&
        'code' in ex && typeof ex.code === 'string');
};
exports.isCustomError = isCustomError;
